// Upcoming / Past event cards (mockup viewAdmin events branch; counts per components/admin/PastEventCard.js).
import React from "react";
import Icon from "../../../components/Icon";
import { Button, IconButton, Pill } from "../../../components/primitives";
import { isEventInOTPWindow, toDate } from "../../../lib/format";
import { dayLabel, dayOfMonth, monthShort, timeLabel } from "../../../../../utils/eventDateParts";
import { hueFor, photo } from "../../../lib/gradients";

function Poster({ event, past }) {
  const d = toDate(event.start_date);
  const hasImg = typeof event.image_url === "string" && event.image_url.trim();
  const style = {
    width: 84,
    minHeight: 84,
    background: hasImg ? `center / cover url("${event.image_url}")` : photo(hueFor(event.id)),
  };
  return (
    <div className={`poster${past ? " ev-poster-past" : ""}`} style={style}>
      {d && (
        <span className="stub">
          <small>{monthShort(d)}</small>
          <b>{dayOfMonth(d)}</b>
        </span>
      )}
    </div>
  );
}

export function UpcomingCard({ event, canDelete, editLocked, onQR, onEdit, onDelete }) {
  const d = toDate(event.start_date);
  const live = isEventInOTPWindow(event);
  const pub = event.is_public !== false;
  return (
    <div className="card pad row wrap" style={{ gap: 14 }}>
      <Poster event={event} />
      <div className="grow col" style={{ gap: 4, minWidth: 200 }}>
        <div className="row" style={{ gap: 6 }}>
          {live && <Pill tone="live">LIVE NOW</Pill>}
          <Pill tone={pub ? "blue" : "purple"}>{pub ? "Public" : "Private"}</Pill>
        </div>
        <b style={{ fontSize: 16 }}>{event.title}</b>
        {d && <div className="inforow"><Icon name="clock" />{dayLabel(d)} · {timeLabel(d)}</div>}
        {event.location && <div className="inforow"><Icon name="pin" />{event.location}</div>}
        {editLocked && <div className="tiny muted">Finishing photo upload…</div>}
      </div>
      <div className="row wrap">
        <Button variant="sec" size="xs" icon="qr" onClick={() => onQR(event)} data-testid={`manage.events.row.${event.id}.qr`}>Check-in QR</Button>
        <IconButton icon="edit" label="Edit event" size={16} disabled={editLocked} onClick={() => onEdit(event)} data-testid={`manage.events.row.${event.id}.edit`} />
        {canDelete && <IconButton icon="trash" label="Delete event" size={16} className="ev-danger" onClick={() => onDelete(event)} data-testid={`manage.events.row.${event.id}.delete`} />}
      </div>
    </div>
  );
}

export function PastCard({ event, onAdd, onView }) {
  const checked = Number(event.checkIn_count) || 0;
  const rsvps = Number(event.attendee_count) || 0;
  const pct = rsvps > 0 ? Math.min(100, Math.round((checked / rsvps) * 100)) : 0;
  return (
    <div className="card pad row wrap" style={{ gap: 14 }}>
      <Poster event={event} past />
      <div className="grow col" style={{ gap: 6, minWidth: 200 }}>
        <Pill tone="gray" style={{ alignSelf: "flex-start" }}>Ended</Pill>
        <b style={{ fontSize: 16 }}>{event.title}</b>
        <div className="row" style={{ justifyContent: "space-between" }}>
          <div className="meta tnum">{rsvps > 0 ? `${checked} of ${rsvps} checked in` : `${checked} checked in`}</div>
          {rsvps > 0 && <div className="meta tnum">{pct}% attendance</div>}
        </div>
        {rsvps > 0 && <div className="bar"><i style={{ width: `${pct}%` }} /></div>}
      </div>
      <div className="row">
        <Button variant="sec" size="xs" onClick={() => onAdd(event)} data-testid={`manage.events.row.${event.id}.addAttendees`}>Add attendees</Button>
        <Button variant="ghost" size="xs" onClick={() => onView(event)} data-testid={`manage.events.row.${event.id}.viewAttendees`}>View attendees</Button>
      </div>
    </div>
  );
}
